import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/enum/ToasterMessages';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ClientService } from 'src/app/shared/services/client.service';
import { LeagalServiceService } from 'src/app/shared/services/leagal-service.service';
import { UserService } from 'src/app/shared/services/user.service';

@Component({
  selector: 'legal-update-payment-discount',
  templateUrl: './update-payment-discount.component.html',
  styleUrls: ['./update-payment-discount.component.scss']
})
export class UpdatePaymentDiscountComponent implements OnInit, AfterViewInit, OnChanges {

  registerForm: FormGroup;
  submitted: boolean = false;
  ownerId: string;
  users: Array<any> = [];
  updateTypes: Array<string> = ['Payment', 'Discount','Home Loan Discount','Refund','Cancel'];
  isDiscountEnabled: boolean = false;
  @Input() clientServiceId: string = '';
  @Input() paymentDone: string = '0';
  @Output() closeModal = new EventEmitter<boolean>();
  todaysDate: Date = new Date();
  userDetail: any = null;


  constructor(private formBuilder: FormBuilder,
    private legalService: LeagalServiceService,
    private router: Router,
    private toasterService: ToastrService,
    private userService: UserService,
    private authService: AuthService,
    private clientService: ClientService) { }


  ngOnChanges(changes: SimpleChanges): void {
    console.log(this.clientServiceId);
  }

  ngOnInit(): void {
    this.initializeForm();
    //this.loadUserInfo();
  }

  private loadUserInfo() {
    this.userDetail = this.authService.currentUser$
      .subscribe(result => {
        this.userDetail = result;
      });
  }

  ngAfterViewInit(): void {
  }

  get f() { return this.registerForm.controls; }

  private initializeForm() {
    this.registerForm = this.formBuilder.group({
      type: ['', Validators.required],
      discount: [],
      paymentDate: [],
      paymentDone: []
    });
    const currentDate = new Date();

    this.registerForm.get('paymentDate')?.setValue(this.formatDateToMMDDYYYY(this.todaysDate));
    this.registerForm.get('type')?.setValue('Payment');
    this.registerForm.get('paymentDone')?.setValue(parseInt(this.paymentDone));
  }

  public onUpdateTypeChange() {
    const type = this.registerForm.value.type;
    this.isDiscountEnabled = type === 'Discount' || type === 'Home Loan Discount' || type === 'Refund' || type === 'Cancel';
    const fields = ['discount', 'paymentDone', 'paymentDate']
    fields.forEach(element => {
      this.registerForm.get(element)?.clearValidators();
      this.registerForm.get(element)?.updateValueAndValidity();
    })

  }

  public setValidation() {
    if (this.isDiscountEnabled) {
      this.registerForm.get('discount')?.addValidators([Validators.required]);
      this.registerForm.get('discount')?.updateValueAndValidity();

      this.registerForm.get('paymentDate')?.removeValidators([Validators.required]);
      this.registerForm.get('paymentDate')?.updateValueAndValidity();

      this.registerForm.get('paymentDone')?.setValue(null);
      this.registerForm.get('paymentDone')?.removeValidators([Validators.required]);
      this.registerForm.get('paymentDone')?.updateValueAndValidity();


    } else {
      this.registerForm.get('paymentDate')?.addValidators([Validators.required]);
      this.registerForm.get('paymentDate')?.updateValueAndValidity();

      this.registerForm.get('paymentDone')?.addValidators([Validators.required]);
      this.registerForm.get('paymentDone')?.updateValueAndValidity();

      this.registerForm.get('discount')?.removeValidators([Validators.required]);
      this.registerForm.get('discount')?.updateValueAndValidity();

    }
  }

  public register() {
    this.submitted = true;
    // stop here if form is invalid
    // this.setValidation();
    // if (this.registerForm.invalid) {
    //   alert('invalid');
    //     return;
    // }
    let requestBody = this.registerForm.value;
    requestBody['id'] = this.clientServiceId
    requestBody['updatedBy'] = this.authService.getCurrentUser()?.userName;
    requestBody['isDiscountEnabled'] = this.isDiscountEnabled;
    this.updateDetails(requestBody)

  }


  private updateDetails(request: any) {
    //alert(JSON.stringify(request));
    this.clientService.UpdatePaymentOrDiscount(request)
      .subscribe(result => {
        this.toasterService.success(`${this.isDiscountEnabled ? 'Dicount' : 'Payment'} ${ToasterMessages.Update}`, ToasterMessages.SucccessTitle);
        this.closeModal.emit(true);
        //this.router.navigate(['/sample-page/clients'])
      },
        error => {
          console.log(error);
          this.toasterService.error(error.error.message, ToasterMessages.ErrorTitle)
        });
  }

  public closePopup() {
    this.closeModal.emit(true);

  }

  private formatDateToMMDDYYYY(date: Date): string {
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${yyyy}-${mm}-${dd}`;
  }



}
